import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/forgotten-password')({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/mot-de-passe-oublie' })
  },
})
